import ShimmerLoader from '@components/ShimmerLoader/ShimmerLoader';

import styles from './Card.module.scss';

interface LoaderProps {
  mode: 'fit' | 'standalone';
}
const Loader: React.FC<React.PropsWithChildren<LoaderProps>> = ({ mode, children, ...props }) => {
  return (
    <div className={styles['card-loader']} data-mode={mode}>
      <div className={styles['card-loader-header']} {...props}></div>
      {children}
      <div className={styles['card-loader-details-section']}>
        <div className={styles['card-loader-long-section']} {...props}></div>
        <div className={styles['card-loader-med-section']} {...props}></div>
        <div className={styles['card-loader-med-section']} {...props}></div>
      </div>

      <div className={styles['card-loader-field-container']}>
        <div className={styles['card-loader-field-icon']} {...props}></div>
        <div className={styles['card-loader-field-details']}>
          <div className={styles['card-loader-med-section']} {...props}></div>
        </div>
      </div>
    </div>
  );
};
const CardLoader: React.FC<React.PropsWithChildren<LoaderProps>> = ({ mode, children }) => {
  return (
    <ShimmerLoader>
      {(props) => (
        <Loader mode={mode} {...props}>
          {children}
        </Loader>
      )}
    </ShimmerLoader>
  );
};

export default CardLoader;
